import { SIDEBAR_STATE_KEY, SIDEBAR_STATE_WIDTH_KEY } from '../utils/constants';
import { ref } from '@vue/reactivity';
import { watch } from '@vue-reactivity/watch';
import { createNanoEvents, Emitter } from 'nanoevents';

export type TSidebarEventsMap = {
  width: (event: number) => void;
  isOpen: (event: boolean) => void;
};

const eventBus: Emitter<TSidebarEventsMap> = createNanoEvents();

export type SidebarStoreState = {
  isOpen: boolean;
  width: number;
};

const defaults: SidebarStoreState = {
  isOpen: true,
  width: 300
};

const loadDefaults = () => {
  try {
    defaults.isOpen = localStorage.getItem(SIDEBAR_STATE_KEY) === 'true';
    defaults.width = localStorage.getItem(SIDEBAR_STATE_WIDTH_KEY)
      ? Number(localStorage.getItem(SIDEBAR_STATE_WIDTH_KEY))
      : 300;
  } catch (e) {
    console.error(e);
  }
};

loadDefaults();

const isOpen = ref<boolean>(defaults.isOpen);
const width = ref<number>(defaults.width);

watch(
  isOpen,
  () => {
    document.body.classList.toggle('is-sidebar-hidden', !isOpen.value);
  },
  { immediate: true }
);

watch(
  width,
  () => {
    document.documentElement.style.setProperty(
      '--v-theme-sidebar-width',
      width.value + 'px'
    );
  },
  { immediate: true }
);

watch(isOpen, () => {
  try {
    localStorage.setItem(SIDEBAR_STATE_KEY, String(isOpen.value));
  } catch (e) {
    console.error(e);
  }
});

watch(width, () => {
  try {
    localStorage.setItem(SIDEBAR_STATE_WIDTH_KEY, String(width.value));
  } catch (e) {
    console.error(e);
  }
});

watch(isOpen, () => {
  eventBus.emit('isOpen', isOpen.value);
});

watch(width, () => {
  eventBus.emit('width', width.value);
});

const setWidth = (newWidth: number) => {
  width.value = newWidth;
};

const toggle = () => {
  isOpen.value = !isOpen.value;
};

export const sidebarStore = {
  isOpen,
  width,
  setWidth,
  toggle,
  eventBus
};
